var _metadata, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAdmin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1000 1000",
    enableBackground: "new 0 0 1000 1000",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, " Svg Vector Icons : http://www.onlinewebfonts.com/icon ")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M571.2,920.5h279v70.1h-279V920.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M757.9,388.3c-4-13-10.3-24.9-18.3-35.1c22-120.4-10.5-197.2-44.3-241.9C647.1,47.5,566.7,9.4,480.1,9.4c-86.6,0-167,38.1-215.2,101.9c-33.7,44.7-66.3,121.5-44.3,241.9c-8,10.2-14.3,22.1-18.3,35.1c-5.7,18.6-17,78.2,45.5,136.1c6.2,52.2,29.2,86.7,49.8,107.6c0,2.1,0,4.2,0,6.2c-4.8,1.6-10.1,3.4-15.9,5.3C199.6,671.4,7.1,736.5,10,921.7c0.6,38.3,31.8,68.9,70.1,68.9h281.7v-70.1H80.1C77.2,743,333.8,714.1,355,688.1c21.2-26,9.6-91.6,9.6-91.6s-51.1-26-48.2-107.1c-82.9-55.9-40.5-110-16.4-104.2C233.4,151.1,381.5,79.5,480.1,79.5c98.6,0,246.7,71.6,180,305.7c14.9-3.6,36.6,15.7,31.7,44h70.1C763.2,410.8,760.2,396,757.9,388.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.5,500v350.4H990V500H427.5z M919.9,780.3H497.6V570.1h422.3V780.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M676.8,850.4h67.9v105.1h-67.9V850.4z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdmin);
export default __webpack_public_path__ + "static/media/admin.02e454976ff6fcd35ab62fb011b14976.svg";
export { ForwardRef as ReactComponent };